module.exports = __webpack_public_path__ + "img/BOC.c68b4c8f.png";